import dayjs from "dayjs";

export const SCORE_MIN = 1;
export const SCORE_MAX = 10;
export const SCALE = Array.from({ length: 10 }, (_, i) => i + 1);

export const DEFAULT_METRICS = [
  { key: "morning_feeling", label: "Morning Wellbeing", short: "AM", description: "How you felt at the start of the day" },
  { key: "evening_feeling", label: "Evening Wellbeing", short: "PM", description: "How you felt at the end of the day" },
  { key: "activity_level", label: "Activity Level", short: "Act", description: "How active you were today" },
];

export const METRIC_COLORS = {
  morning_feeling: "#F59E0B",
  evening_feeling: "#0D9488",
  activity_level: "#F43F5E",
};
const FALLBACK_COLORS = ["#14B8A6", "#EF4444", "#8B5CF6", "#EC4899", "#0EA5E9", "#F97316"];

export function metricColor(key, idx = 0) {
  return METRIC_COLORS[key] || FALLBACK_COLORS[idx % FALLBACK_COLORS.length];
}

function hueFor(v) {
  const c = Math.max(SCORE_MIN, Math.min(SCORE_MAX, v));
  return Math.round(((c - 1) / 9) * 130); // 0 = red (low) -> 130 = green (high)
}

export function scoreColor(v) {
  if (v == null || isNaN(v)) return "hsl(215 16% 72%)";
  return `hsl(${hueFor(v)} 62% 44%)`;
}

export function scoreTint(v) {
  if (v == null || isNaN(v)) return "transparent";
  return `hsl(${hueFor(v)} 62% 94%)`;
}

export function scoreBorder(v) {
  if (v == null || isNaN(v)) return "hsl(var(--border))";
  return `hsl(${hueFor(v)} 55% 78%)`;
}

export function average(nums) {
  const arr = (nums || []).filter((n) => n != null && !isNaN(n));
  if (!arr.length) return null;
  return arr.reduce((a, b) => a + b, 0) / arr.length;
}

export function dayAverage(entry) {
  if (!entry || !entry.metrics) return null;
  return average(Object.values(entry.metrics));
}

export function metricAverage(entries, key) {
  return average((entries || []).map((e) => e.metrics?.[key]).filter((v) => v != null));
}

export function estToday() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "America/New_York" }).format(new Date());
}

export function fmt(d) {
  return dayjs(d).format("YYYY-MM-DD");
}
